import { Modal, ModalBody, ModalContent, ModalHeader } from "@heroui/react";
import { OrderCardDetailed } from "../order-card-detailed";
import type { Order } from "@/api.types.v2";
import { useTranslation } from "react-i18next";

interface OrderDetailsDialogProps {
  order: Order;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function OrderDetailsDialog({
  order,
  open,
  onOpenChange,
}: OrderDetailsDialogProps) {
  const { t } = useTranslation("app");

  return (
    <Modal
      isOpen={open}
      onOpenChange={onOpenChange}
      placement="center"
      backdrop="blur"
      disableAnimation
      size="4xl"
      scrollBehavior="inside"
      classNames={{
        base: "m-0 sm:m-1 max-h-screen sm:max-h-[90vh] rounded-none sm:rounded-large",
      }}
    >
      <ModalContent>
        <ModalHeader>{t("orderDetails.dialogTitle")}</ModalHeader>
        <ModalBody className="pb-6">
          <OrderCardDetailed order={order} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
